<rt-avatar
  [type]="data.type"
  [size]="size()"
  [shape]="'oval'"
  [initials]="data.initials"
  [imageSrc]="data.imageSrc"
  [iconName]="data.iconName"
  [context]="data.context"
/>
